<script>
export const group = 'Full'
</script>

<script setup>
import ToFullBottomRight from './transitions/energetic_frequencies/ToFullBottomRight.vue'
import MysterySoundAmount from '../screens_qmusic_nl_default/MysterySoundAmount.vue'
import MysterySoundAmountBackground from '../../../assets/images/mystery_sound_amount_background.png'
import VideoPlayer from '../../VideoPlayer.vue'

const props = defineProps({
  item: Object,
})

const backgroundVideo = computed(() => props.item.properties?.backgroundVideo || null)
</script>

<template>
  <ToFullBottomRight>
    <MysterySoundAmount :item="item" />
    <VideoPlayer v-if="backgroundVideo" :src="backgroundVideo" autoplay muted loop class="size-full object-cover" />
    <img v-else :src="MysterySoundAmountBackground" class="size-full" />
  </ToFullBottomRight>
</template>
